import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Col, Row, Card, Table, Form, Button, Badge, Spinner } from '@themesberg/react-bootstrap'
import { getAllEmployees, updateStatus, logoutWorkTimeById, getAvailableGames, assignGame } from '../../../../controller/api/employee';
import WorkTime from '../sub-screen/work-time/WorkTime'
import { useCookies } from 'react-cookie';
import AddNewEmployee from '../sub-screen/add-new/AddNewEmployee';
import EditEmployee from '../sub-screen/edit/EditEmployee';
import GameAssignModal from '../sub-screen/game-assign/GameAssignModal';

import { canCreateEmployees } from '../../../../helper/permission'

const TableRow = (props) => {
  const { username, name, workTime, onStatusChange, status, id, onShowWorkTime, onLogout, onAssignGame, onEdit, phone, identify, assignedGameDetails } = props;

  // Lấy thông tin games hiện tại từ assignedGameDetails (persistent, không bị mất khi logout)
  const currentGames = assignedGameDetails || [];

  return (
    <tr>
      <td>
        <Button variant="info" size="sm" className="m-1" onClick={() => onShowWorkTime(id)}>
          Xem thời gian
        </Button>
        {workTime && workTime.length > 0 &&
          <Button variant="danger" size="sm" className="m-1" onClick={() => onLogout(workTime[0].id, id)}>
            Đăng xuất
          </Button>
        }
        <Button variant="warning" size="sm" className="m-1" onClick={() => onAssignGame(id, username, currentGames)}>
          Gán Games
        </Button>
        <Button variant="primary" size="sm" className="m-1" onClick={() => onEdit({ id, username, name, phone, identify })}>
          Chỉnh sửa
        </Button>
      </td>
      <td>
        <div className="fw-bold">{username || ""}</div>
        {name && <small className="text-muted">{name}</small>}
      </td>
      <td>
        {currentGames.length > 0 ? (
          <div>
            {currentGames.map((game, index) => (
              <Badge key={game.id} bg="success" className="me-1 mb-1">
                {game.name}
              </Badge>
            ))}
            {currentGames.length > 1 && (
              <div>
                <small className="text-muted">({currentGames.length} games)</small>
              </div>
            )}
          </div>
        ) : (
          <Badge bg="secondary">Chưa gán game</Badge>
        )}
      </td>
      <td style={{ width: 200 }}>
        <Form.Select value={status} onChange={(evt) => onStatusChange(evt, id)} >
          <option value={0}>Không hoạt động</option>
          <option value={1}>Hoạt động</option>
        </Form.Select>
      </td>
    </tr>
  );
};

export const EmployeeTable = () => {

  const [listEmployee, setListEmployee] = useState({})

  const [loading, setLoading] = useState(true)

  const [modalShow, setModalShow] = useState(false)

  const [addModalShow, setAddModalShow] = useState(false)

  const [gameAssignModalShow, setGameAssignModalShow] = useState(false)

  const [editModalShow, setEditModalShow] = useState(false)

  const [cookies] = useCookies(['lottmekong'])

  const employeeIdRef = useRef(null)

  const employeeNameRef = useRef(null)

  const gameAssignEmployeeRef = useRef(null)

  const editEmployeeRef = useRef(null)

  const fetchEmployees = useCallback(async () => {
    setLoading(true)
    try {
      const list = await getAllEmployees(cookies.lottmekong)

      if (list) {
        const res = {
          data: list.data,
          total: list.total,
          isOff: list.data.filter(item => item.status === 0).length,
          isOn: list.data.filter(item => item.status === 1).length,
        }
        setListEmployee(res || {})
      } else {
        setListEmployee({})
      }
    } catch (err) {
      console.error('fetchEmployees error:', err)
      setListEmployee({})
    } finally {
      setLoading(false)
    }
  }, [cookies.lottmekong])

  useEffect(() => {
    fetchEmployees()
  }, [fetchEmployees])

  const onShowWorkTime = (id, name) => {
    employeeIdRef.current = id
    employeeNameRef.current = name
    setModalShow(true)
  }

  const onLogout = async (id, employeeId) => {
    const resp = await logoutWorkTimeById(cookies.lottmekong, id)
    if (resp) {
      const _newData = JSON.parse(JSON.stringify(listEmployee))

      _newData.data = _newData.data.map(it => {
        if (it.id === employeeId) {
          it.workTimes = []
        }
        return {
          ...it
        }
      })
      setListEmployee(_newData)
    } else {
      alert('Có lỗi xảy ra')
      return false
    }
  }

  const onStatusChange = async (evt, id) => {
    const newStatus = evt.target.value
    const resp = await updateStatus(cookies.lottmekong, id, newStatus)
    if (resp) {
      await fetchEmployees()
    } else {
      alert('Có lỗi xảy ra')
      return false
    }
  }

  const onAddPress = async () => {
    setAddModalShow(true)
  }

  const onAssignGame = (employeeId, employeeName, currentGames) => {
    gameAssignEmployeeRef.current = {
      id: employeeId,
      name: employeeName,
      currentGames: currentGames,
      // Backward compatibility
      currentGame: currentGames.length > 0 ? currentGames[0] : null
    }
    setGameAssignModalShow(true)
  }

  const onEditEmployee = (employeeInfo) => {
    editEmployeeRef.current = employeeInfo
    setEditModalShow(true)
  }

  const onEditSuccess = async () => {
    await fetchEmployees()
    setEditModalShow(false)
  }

  const onGameAssignSuccess = async () => {
    await fetchEmployees()
    setGameAssignModalShow(false)
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col>
              <h5>Nhân viên in vé ({listEmployee.total})</h5>
            </Col>
            <Col className="text-end">
              {canCreateEmployees() && (
                <Button className='mb-3' style={{ marginRight: 20 }} variant="success" type="button" onClick={onAddPress}>Thêm nhân viên in vé</Button>
              )}
            </Col>
          </Row>
        </Card.Header>
        <Table responsive className="align-items-center table-flush">
          <thead className="thead-light">
            <tr>
              <th scope="col">Thao tác</th>
              <th scope="col">Tên đăng nhập</th>
              <th scope="col">Game được gán</th>
              <th scope="col">Trạng thái</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan="4" className="text-center py-4">
                  <Spinner animation="border" className="me-2" />
                  Đang tải dữ liệu...
                </td>
              </tr>
            ) : listEmployee.data && listEmployee.data.length > 0 ? (
              listEmployee.data.map(pv => (
                <TableRow
                  onLogout={onLogout}
                  onShowWorkTime={onShowWorkTime}
                  onStatusChange={onStatusChange}
                  onAssignGame={onAssignGame}
                  onEdit={onEditEmployee}
                  key={`device-status-${pv.id}`}
                  {...pv}
                />
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center py-4 text-muted">
                  Không có nhân viên nào
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>
      <WorkTime
        show={modalShow}
        employeeId={employeeIdRef.current}
        employeeName={employeeNameRef.current}
        onHide={() => setModalShow(false)}
      />
      <AddNewEmployee
        show={addModalShow}
        onHide={() => setAddModalShow(false)}
        onSuccess={fetchEmployees}
      />
      <GameAssignModal
        show={gameAssignModalShow}
        onHide={() => setGameAssignModalShow(false)}
        employee={gameAssignEmployeeRef.current}
        onSuccess={onGameAssignSuccess}
      />
      <EditEmployee
        show={editModalShow}
        onHide={() => setEditModalShow(false)}
        employee={editEmployeeRef.current}
        onSuccess={onEditSuccess}
      />
    </>
  );
};
